"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("lodash/map"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var actions = _interopRequireWildcard(require("../resources/webRTC/actions"));
var _debug = require("./debug");
var _array = require("./array");
var _streams2 = require("./streams");
var _constants = require("../resources/webRTC/constants");
var _callbacks = _interopRequireDefault(require("../callbacks"));
var _errorHandler = _interopRequireDefault(require("./errorHandler"));
var _logger = _interopRequireDefault(require("./logger"));
var _excluded = ["takeLast", "_client", "_entity"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
var logger = new _logger.default('utils:StreamManager');
var _streams = /*#__PURE__*/new WeakMap();
var _audioStreams = /*#__PURE__*/new WeakMap();
var _audioTracks = /*#__PURE__*/new WeakMap();
var _videoStreams = /*#__PURE__*/new WeakMap();
var _videoTracks = /*#__PURE__*/new WeakMap();
var _myClient = /*#__PURE__*/new WeakMap();
var _focus = /*#__PURE__*/new WeakMap();
var _stats = /*#__PURE__*/new WeakMap();
class StreamManager {
  constructor() {
    var _this = this;
    _classPrivateFieldInitSpec(this, _streams, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _audioStreams, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _audioTracks, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _videoStreams, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _videoTracks, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _myClient, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _focus, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _stats, {
      writable: true,
      value: {}
    });
    _defineProperty(this, "getMyClient", () => _classPrivateFieldGet(this, _myClient));
    _defineProperty(this, "getLocalTracks", () => {
      var tracks = {};
      for (var _entity in _classPrivateFieldGet(this, _audioTracks)) {
        tracks[_entity] = {
          audio: _classPrivateFieldGet(this, _audioTracks)[_entity],
          video: _classPrivateFieldGet(this, _videoTracks)[_entity]
        };
      }
      for (var _entity2 in _classPrivateFieldGet(this, _videoTracks)) {
        tracks[_entity2] = {
          audio: _classPrivateFieldGet(this, _audioTracks)[_entity2],
          video: _classPrivateFieldGet(this, _videoTracks)[_entity2]
        };
      }
      return tracks;
    });
    _defineProperty(this, "getLocalTracksByEntity", _entity => this.getLocalTracks()[_entity]);
    _defineProperty(this, "getLocalStream", /*#__PURE__*/_asyncToGenerator(function* () {
      var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4;
      var {
        audio,
        video,
        screen,
        _client,
        token,
        _entity
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classPrivateFieldSet(_this, _myClient, _client);
      logger.log('getLocalStream', {
        _client,
        token,
        _entity,
        audio,
        video,
        screen,
        streams: _classPrivateFieldGet(_this, _streams),
        audioStream: _classPrivateFieldGet(_this, _audioStreams)[_entity],
        audioTrack: _classPrivateFieldGet(_this, _audioTracks)[_entity],
        videoStream: _classPrivateFieldGet(_this, _videoStreams)[_entity],
        videoTrack: _classPrivateFieldGet(_this, _videoTracks)[_entity]
      }, token);
      if (!audio && !video && !screen) return undefined;
      var stream;
      if (audio && !((_classPrivateFieldGet2 = _classPrivateFieldGet(_this, _audioStreams)[_entity]) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.active)) {
        _classPrivateFieldGet(_this, _audioStreams)[_entity] = _this.createNewStream('audio');
      }
      if (screen && (!((_classPrivateFieldGet3 = _classPrivateFieldGet(_this, _videoStreams)[_entity]) !== null && _classPrivateFieldGet3 !== void 0 && _classPrivateFieldGet3.active) || !(0, _streams2.isScreenSharingStream)(_classPrivateFieldGet(_this, _videoStreams)[_entity]))) {
        _classPrivateFieldGet(_this, _videoStreams)[_entity] = _this.createNewStream('screen');
      } else if (video && (!((_classPrivateFieldGet4 = _classPrivateFieldGet(_this, _videoStreams)[_entity]) !== null && _classPrivateFieldGet4 !== void 0 && _classPrivateFieldGet4.active) || !(0, _streams2.isCameraStream)(_classPrivateFieldGet(_this, _videoStreams)[_entity]))) {
        _classPrivateFieldGet(_this, _videoStreams)[_entity] = _this.createNewStream('video');
      }
      if (!token) {
        // stream only use to render your face on the screen waiting and will never be associated to a PC
        // it should be only one of them in this specific case : audio OR video
        if (audio) {
          var _classPrivateFieldGet5;
          _classPrivateFieldGet(_this, _audioStreams)[_entity] = yield _classPrivateFieldGet(_this, _audioStreams)[_entity];
          if ((_classPrivateFieldGet5 = _classPrivateFieldGet(_this, _audioStreams)[_entity]) !== null && _classPrivateFieldGet5 !== void 0 && _classPrivateFieldGet5.active) {
            var [audioTrack] = (0, _streams2.getTracks)(_classPrivateFieldGet(_this, _audioStreams)[_entity], 'audio');
            _classPrivateFieldGet(_this, _audioTracks)[_entity] = audioTrack;
          }
        }
        if (video || screen) {
          var _classPrivateFieldGet6;
          _classPrivateFieldGet(_this, _videoStreams)[_entity] = yield _classPrivateFieldGet(_this, _videoStreams)[_entity];
          if ((_classPrivateFieldGet6 = _classPrivateFieldGet(_this, _videoStreams)[_entity]) !== null && _classPrivateFieldGet6 !== void 0 && _classPrivateFieldGet6.active) {
            var [videoTrack] = (0, _streams2.getTracks)(_classPrivateFieldGet(_this, _videoStreams)[_entity], 'video');
            _classPrivateFieldGet(_this, _videoTracks)[_entity] = videoTrack;
          }
        }
        logger.log('getLocalStream without token', token);
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity,
          _client
        }));
        return video || screen ? _classPrivateFieldGet(_this, _videoStreams)[_entity] : _classPrivateFieldGet(_this, _audioStreams)[_entity];
      }
      if (token) {
        stream = _this.getStreamByToken({
          _client,
          token
        });
        logger.log('getLocalStream with token', stream, token);
        if (stream) return stream;
      }
      try {
        if (!_callbacks.default.isExist('MediaStream')) return undefined;
        var _CustomMediaStream = _callbacks.default.get('MediaStream');
        var _stream = new _CustomMediaStream();
        if (audio) {
          var audioStream = yield _classPrivateFieldGet(_this, _audioStreams)[_entity];
          if (audioStream !== null && audioStream !== void 0 && audioStream.active) {
            var [_audioTrack] = (0, _streams2.getTracks)(audioStream, 'audio');
            _classPrivateFieldGet(_this, _audioTracks)[_entity] = _audioTrack;
          }
          if (_classPrivateFieldGet(_this, _audioTracks)[_entity]) {
            try {
              _stream.addTrack(_classPrivateFieldGet(_this, _audioTracks)[_entity]);
            } catch (e) {
              logger.warn('track error', 'audio', e, token);
            }
          } else {
            logger.warn('No audio Track to add ', _classPrivateFieldGet(_this, _audioTracks)[_entity], token);
          }
        }
        if (video || screen) {
          var videoStream = yield _classPrivateFieldGet(_this, _videoStreams)[_entity];
          if (videoStream !== null && videoStream !== void 0 && videoStream.active) {
            var [_videoTrack] = (0, _streams2.getTracks)(videoStream, 'video');
            _classPrivateFieldGet(_this, _videoTracks)[_entity] = _videoTrack;
          }
          if (_classPrivateFieldGet(_this, _videoTracks)[_entity]) {
            try {
              _stream.addTrack(_classPrivateFieldGet(_this, _videoTracks)[_entity]);
            } catch (e) {
              logger.warn('track error', 'video', e, token);
            }
          } else {
            logger.warn('No video Track to add', _classPrivateFieldGet(_this, _videoTracks)[_entity], token);
          }
        }
        _this.setStream({
          _client,
          token,
          stream: _stream,
          _entity,
          profile: {
            audio,
            video,
            screenSharing: screen
          },
          remote: false
        });
        return _stream;
      } catch (e) {
        logger.warn('createAndSetNewStream error', {
          error: e
        }, token);
        return undefined;
      }
    }));
    _defineProperty(this, "createNewStream", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (kind) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        logger.log('createNewStream', _objectSpread({
          kind
        }, args));
        var permissions = kind === '*' ? ['audio', 'video'] : [kind];
        if (_callbacks.default.isExist('requestPermissions')) {
          yield _callbacks.default.get('requestPermissions')(permissions);
        }
        // RN Webrtc does not support addTrack after renegotiation,
        // so we have to create both stream (video+audio) and deactivate video
        // if not required
        try {
          return _callbacks.default.get('getStream')(kind);
        } catch (e) {
          logger.error('createNewStream', e);
          return undefined;
        }
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getAudioStreams", _ref3 => {
      var _classPrivateFieldGet7, _classPrivateFieldGet8;
      var {
        _client,
        _entity,
        enabled = true,
        checkEnabled = true
      } = _ref3;
      if (!_client) return [];
      if (_client === _classPrivateFieldGet(this, _myClient) && (_classPrivateFieldGet7 = _classPrivateFieldGet(this, _audioStreams)[_entity]) !== null && _classPrivateFieldGet7 !== void 0 && _classPrivateFieldGet7.id) {
        return !(0, _streams2.isTrackEnabled)(_classPrivateFieldGet(this, _audioTracks)[_entity]) ? [] : [_classPrivateFieldGet(this, _audioStreams)[_entity]];
      }
      if (!((_classPrivateFieldGet8 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet8 !== void 0 && _classPrivateFieldGet8.length)) return [];
      var streams = _classPrivateFieldGet(this, _streams)[_client];
      var audioStreams = streams.filter(streamInfo => {
        if (_entity && streamInfo._entity !== _entity || !streamInfo.audio) return false;
        if (!checkEnabled) return true;
        var [track] = (0, _streams2.getTracks)(streamInfo.stream, 'audio');
        return (0, _streams2.isTrackEnabled)(track) === enabled;
      });
      return audioStreams.reduce((acc, audioStream) => [...acc, audioStream.stream], []);
    });
    _defineProperty(this, "getAudioStream", args => {
      var [stream] = this.getAudioStreams(args).slice(-1);
      return stream;
    });
    _defineProperty(this, "getVideoStreams", _ref4 => {
      var _classPrivateFieldGet9, _classPrivateFieldGet10;
      var {
        _client,
        _entity,
        enabled = true,
        checkEnabled = true
      } = _ref4;
      if (!_client) return [];
      if (_client === _classPrivateFieldGet(this, _myClient) && (_classPrivateFieldGet9 = _classPrivateFieldGet(this, _videoStreams)[_entity]) !== null && _classPrivateFieldGet9 !== void 0 && _classPrivateFieldGet9.id) {
        return !(0, _streams2.isTrackEnabled)(_classPrivateFieldGet(this, _videoTracks)[_entity]) ? [] : [_classPrivateFieldGet(this, _videoStreams)[_entity]];
      }
      if (!((_classPrivateFieldGet10 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet10 !== void 0 && _classPrivateFieldGet10.length)) return [];
      var streams = _classPrivateFieldGet(this, _streams)[_client];
      var videoStreams = streams.filter(streamInfo => {
        if (_entity && streamInfo._entity !== _entity || !streamInfo.video && !streamInfo.screenSharing && !streamInfo.screenSharing) return false;
        if (!checkEnabled) return true;
        var [track] = (0, _streams2.getTracks)(streamInfo.stream, 'video');
        return (0, _streams2.isTrackEnabled)(track) === enabled;
      });
      return videoStreams.reduce((acc, videoStream) => [...acc, videoStream.stream], []);
    });
    _defineProperty(this, "getVideoStream", _ref5 => {
      var {
          takeLast,
          _client,
          _entity
        } = _ref5,
        rest = _objectWithoutProperties(_ref5, _excluded);
      var streams = this.getVideoStreams(_objectSpread(_objectSpread({}, rest), {}, {
        _client,
        _entity
      }));

      // takeLast is useful on mobile because sometimes the last stream in the array is enabled but not available.
      // An issue is open and this mechanism should be removed when the streams array is fixed.
      if (takeLast) {
        var _classPrivateFieldGet11;
        if (!streams.length) {
          return undefined;
        }
        var referenceStream = (_classPrivateFieldGet11 = _classPrivateFieldGet(this, _streams)[_client]) === null || _classPrivateFieldGet11 === void 0 ? void 0 : _classPrivateFieldGet11.find(s => s.stream.id === streams[streams.length - 1].id);
        if (!referenceStream) {
          return streams[streams.length - 1];
        }

        // find highest bitrate video stream & return it
        var returnedStream = _classPrivateFieldGet(this, _streams)[_client].reduce((acc, stream) => {
          if (stream.stream.active && stream.video && (((stream === null || stream === void 0 ? void 0 : stream.videoBitrate) || 0) > ((acc === null || acc === void 0 ? void 0 : acc.videoBitrate) || 0) || !acc.stream.active)) {
            return stream;
          }
          return acc;
        }, referenceStream);
        return returnedStream.stream;
      } else {
        return streams[0];
      }
    });
    _defineProperty(this, "getCameraStreams", args => {
      return this.getVideoStreams(args).filter(_streams2.isCameraStream);
    });
    _defineProperty(this, "getCameraStream", args => {
      var [stream] = this.getCameraStreams(args).slice(-1);
      return stream;
    });
    _defineProperty(this, "getScreenStreams", args => {
      return this.getVideoStreams(args).filter(_streams2.isScreenSharingStream);
    });
    _defineProperty(this, "getScreenStream", args => {
      var [stream] = this.getScreenStreams(args).slice(-1);
      return stream;
    });
    _defineProperty(this, "getAudioVideoStreams", _ref6 => {
      var _classPrivateFieldGet12;
      var {
        _client,
        _entity,
        enabled = true,
        checkEnabled = true
      } = _ref6;
      if (!_client || !((_classPrivateFieldGet12 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet12 !== void 0 && _classPrivateFieldGet12.length)) return [];
      var streams = _classPrivateFieldGet(this, _streams)[_client];
      var audioVideoStreams = streams.filter(streamInfo => {
        if (_entity && streamInfo._entity !== _entity || !streamInfo.audio || !streamInfo.video && !streamInfo.screenSharing) {
          return false;
        }
        if (!checkEnabled) return true;
        var [videoTrack] = (0, _streams2.getTracks)(streamInfo.stream, 'video');
        var [audioTrack] = (0, _streams2.getTracks)(streamInfo.stream, 'audio');
        return (0, _streams2.isTrackEnabled)(videoTrack) === enabled && (0, _streams2.isTrackEnabled)(audioTrack) === enabled;
      });
      return audioVideoStreams.reduce((acc, videoStream) => [...acc, videoStream.stream], []);
    });
    _defineProperty(this, "getAudioVideoStream", args => {
      var [stream] = this.getAudioVideoStreams(args).slice(-1);
      return stream;
    });
    _defineProperty(this, "getStreamByToken", _ref7 => {
      var _classPrivateFieldGet13;
      var {
        _client,
        token
      } = _ref7;
      if (!((_classPrivateFieldGet13 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet13 !== void 0 && _classPrivateFieldGet13.length)) return undefined;
      var streamInfo = _classPrivateFieldGet(this, _streams)[_client].find(streamInfo => streamInfo.token === token);
      if (streamInfo) return streamInfo.stream;
      return undefined;
    });
    _defineProperty(this, "getStreamsByEntity", _ref8 => {
      var _classPrivateFieldGet14;
      var {
        _client,
        _entity
      } = _ref8;
      if (!((_classPrivateFieldGet14 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet14 !== void 0 && _classPrivateFieldGet14.length)) return undefined;
      var streamInfo = _classPrivateFieldGet(this, _streams)[_client].filter(streamInfo => streamInfo._entity === _entity);
      if (streamInfo) return streamInfo === null || streamInfo === void 0 ? void 0 : streamInfo.map(si => si === null || si === void 0 ? void 0 : si.stream);
      return undefined;
    });
    _defineProperty(this, "getVideoStreamUrl", function (_ref9) {
      var _stream$toURL;
      var {
        _client,
        _entity
      } = _ref9;
      var takeLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var stream = _this.getVideoStream({
        _client,
        _entity,
        takeLast
      });
      return stream === null || stream === void 0 || (_stream$toURL = stream.toURL) === null || _stream$toURL === void 0 ? void 0 : _stream$toURL.call(stream);
    });
    _defineProperty(this, "setStream", _ref10 => {
      var _stream$getTracks, _stream$getTracks$map, _stream$getVideoTrack, _stream$getTracks2, _stream$getTracks2$ma, _classPrivateFieldGet15;
      var {
        _client,
        stream,
        profile,
        token,
        _entity,
        remote = true
      } = _ref10;
      /// Ex of profile: {key: "high", audio: false, video: true, bitrate: 500}
      logger.log('setStream %s %s %s', _client, JSON.stringify({
        isScreenStream: (0, _streams2.isScreenSharingStream)(stream),
        trackLabel: stream === null || stream === void 0 || (_stream$getTracks = stream.getTracks) === null || _stream$getTracks === void 0 || (_stream$getTracks = _stream$getTracks.call(stream)) === null || _stream$getTracks === void 0 || (_stream$getTracks$map = _stream$getTracks.map) === null || _stream$getTracks$map === void 0 ? void 0 : _stream$getTracks$map.call(_stream$getTracks, _streams2.getTrackLabel),
        _client,
        tracks: stream === null || stream === void 0 || (_stream$getVideoTrack = stream.getVideoTracks) === null || _stream$getVideoTrack === void 0 ? void 0 : _stream$getVideoTrack.call(stream),
        stream: JSON.stringify(stream, null, 2),
        profile,
        _entity
      }, null, 2), token);
      if (profile !== null && profile !== void 0 && profile.screenSharing && remote === false) {
        var _stream$getVideoTrack2;
        stream === null || stream === void 0 || (_stream$getVideoTrack2 = stream.getVideoTracks) === null || _stream$getVideoTrack2 === void 0 || (_stream$getVideoTrack2 = _stream$getVideoTrack2.call(stream)) === null || _stream$getVideoTrack2 === void 0 || _stream$getVideoTrack2.forEach(t => {
          t.screen = true; // eslint-disable-line
        });
      }

      if (!stream) {
        logger.log('setStream abort, because stream is missing', _client, _entity, token);
        return;
      }
      var id = stream.id || stream._reactTag || '';
      if (id === _constants.JANUS_CLIENT_ID) {
        _errorHandler.default.captureMessage('stream.id SHOULD not be equals to "janus"');
      }
      var streamInfo = _objectSpread(_objectSpread({
        trackLabel: stream === null || stream === void 0 || (_stream$getTracks2 = stream.getTracks) === null || _stream$getTracks2 === void 0 || (_stream$getTracks2 = _stream$getTracks2.call(stream)) === null || _stream$getTracks2 === void 0 || (_stream$getTracks2$ma = _stream$getTracks2.map) === null || _stream$getTracks2$ma === void 0 ? void 0 : _stream$getTracks2$ma.call(_stream$getTracks2, _streams2.getTrackLabel),
        _client,
        stream
      }, profile), {}, {
        token,
        id,
        _entity,
        updatedAt: Date.now(),
        remote
      });
      var alreadyExist;
      if ((_classPrivateFieldGet15 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet15 !== void 0 && _classPrivateFieldGet15.length) {
        _classPrivateFieldGet(this, _streams)[_client] = _classPrivateFieldGet(this, _streams)[_client].map(el => {
          if (el.id === id && el.id !== _constants.JANUS_CLIENT_ID) {
            // Stream.id MUST be unique
            // If not, the sd stream will be replaced by hd stream; (e.g stream.id equals janus in all remote streams)
            alreadyExist = true;
            return streamInfo;
          }
          return el;
        });
      }
      if (!alreadyExist) {
        _classPrivateFieldGet(this, _streams)[_client] = (0, _sortBy.default)([...(_classPrivateFieldGet(this, _streams)[_client] || []), streamInfo], ['videoBitrate']);
      } else {
        logger.log('setStream already exist %s %s %s', _client, JSON.stringify(_classPrivateFieldGet(this, _streams)[_client], null, 2), token);
      }
    });
    _defineProperty(this, "replaceTrack", _ref11 => {
      var {
        _client,
        _entity,
        newTrack: track
      } = _ref11;
      if (!track) {
        logger.warn('replaceTrack: no track to replace');
        return;
      }
      var {
        kind
      } = track;
      var streams = kind === 'audio' ? this.getAudioStreams({
        _client,
        _entity,
        checkEnabled: false
      }) : this.getVideoStreams({
        _client,
        _entity,
        checkEnabled: false
      });
      if (!(streams !== null && streams !== void 0 && streams.length)) {
        logger.warn('replaceTrack: no stream with this kind of track', {
          kind
        });
        return;
      }
      if (streams) {
        logger.log('replaceTrack:streams: ', streams, _classPrivateFieldGet(this, _streams));
        (0, _map.default)(streams, (stream, streamId) => {
          if (stream !== null && stream !== void 0 && stream.addTrack) {
            var tracksToRemove = (0, _streams2.getTracks)(stream, kind);
            logger.log('replaceTrack:stream ', {
              stream,
              streamId,
              tracksToRemove,
              tracks: (0, _streams2.getTracks)(stream, kind),
              track
            });
            stream.addTrack(track);
            tracksToRemove.forEach(t => {
              this.setTrackEnabled(t, false, 0, true);
              stream.removeTrack(t);
            });
          } else {
            logger.warn('replaceTrack:stream:fail', {
              stream,
              streamId
            });
          }
        });
        if (kind === 'audio') {
          _classPrivateFieldGet(this, _audioTracks)[_entity] = track;
        }
        if ('video|screen|camera'.includes(kind)) {
          _classPrivateFieldGet(this, _videoTracks)[_entity] = track;
        }
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity,
          _client,
          hasAudio: this.hasAudio({
            _client,
            _entity
          }),
          hasCamera: this.hasCamera({
            _client,
            _entity
          }),
          hasScreen: this.hasScreen({
            _client,
            _entity
          })
        }));
      }
    });
    _defineProperty(this, "setTrackEnabled", function (track, enabled) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
      var stopTrackOnDisable = arguments.length > 3 ? arguments[3] : undefined;
      if (!stopTrackOnDisable && (0, _streams2.isTrackEnabled)(track, false) === enabled) return undefined;

      // react-native-webrtc react to enabled changes by 'set' keyword
      // it is equal to a function call
      track.enabled = enabled; // eslint-disable-line
      if (!enabled && stopTrackOnDisable && track.stop) {
        // use to switch off camera LED indicator
        // anonymous function otherwise error showing : "Uncaught TypeError: Illegal invocation"
        setTimeout(() => track.stop(), delay);
      }
      return track;
    });
    _defineProperty(this, "clearLocalAudioStream", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(function* (_entity) {
        if (!_classPrivateFieldGet(_this, _audioTracks)[_entity]) return;
        try {
          var _classPrivateFieldGet16, _classPrivateFieldGet17;
          (_classPrivateFieldGet16 = (_classPrivateFieldGet17 = _classPrivateFieldGet(_this, _audioTracks)[_entity]).stop) === null || _classPrivateFieldGet16 === void 0 || _classPrivateFieldGet16.call(_classPrivateFieldGet17);
          if (_classPrivateFieldGet(_this, _audioStreams)[_entity]) {
            yield _this.streamRelease(_classPrivateFieldGet(_this, _audioStreams)[_entity]);
          }
          delete _classPrivateFieldGet(_this, _audioTracks)[_entity];
          delete _classPrivateFieldGet(_this, _audioStreams)[_entity];
        } catch (e) {
          logger.warn('#audioTracks[_entity].stop()', e);
        }
      });
      return function (_x2) {
        return _ref12.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clearLocalVideoStream", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(function* (_entity) {
        var _classPrivateFieldGet18, _classPrivateFieldGet19;
        if (!_classPrivateFieldGet(_this, _videoTracks)[_entity]) return;
        logger.log('remove:clearLocalVideoStream: ', _entity, _classPrivateFieldGet(_this, _videoTracks)[_entity], (_classPrivateFieldGet18 = _classPrivateFieldGet(_this, _videoStreams)[_entity]) === null || _classPrivateFieldGet18 === void 0 || (_classPrivateFieldGet19 = _classPrivateFieldGet18.getTracks) === null || _classPrivateFieldGet19 === void 0 ? void 0 : _classPrivateFieldGet19.call(_classPrivateFieldGet18));
        try {
          var _classPrivateFieldGet20, _classPrivateFieldGet21;
          (_classPrivateFieldGet20 = (_classPrivateFieldGet21 = _classPrivateFieldGet(_this, _videoTracks)[_entity]).stop) === null || _classPrivateFieldGet20 === void 0 || _classPrivateFieldGet20.call(_classPrivateFieldGet21);
          if (_classPrivateFieldGet(_this, _videoStreams)[_entity]) {
            yield _this.streamRelease(_classPrivateFieldGet(_this, _videoStreams)[_entity]);
          }
          delete _classPrivateFieldGet(_this, _videoTracks)[_entity];
          delete _classPrivateFieldGet(_this, _videoStreams)[_entity];
        } catch (e) {
          logger.warn('#videoTracks[_entity].stop():', e);
        }
      });
      return function (_x3) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clearLocalCameraStream", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(function* (_entity) {
        if (!_classPrivateFieldGet(_this, _videoTracks)[_entity] || !(0, _streams2.isCameraTrack)(_classPrivateFieldGet(_this, _videoTracks)[_entity])) return;
        _this.clearLocalVideoStream(_entity);
      });
      return function (_x4) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clearLocalScreenStream", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(function* (_entity) {
        if (!_classPrivateFieldGet(_this, _videoTracks)[_entity] || !(0, _streams2.isScreenTrack)(_classPrivateFieldGet(_this, _videoTracks)[_entity])) return;
        _this.clearLocalVideoStream(_entity);
      });
      return function (_x5) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clearLocalStream", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator(function* (_entity) {
        logger.log('clearLocalStream', _entity);
        if (!_classPrivateFieldGet(_this, _myClient)) return;
        if (_classPrivateFieldGet(_this, _audioTracks)[_entity]) yield _this.clearLocalAudioStream(_entity);
        if (_classPrivateFieldGet(_this, _videoTracks)[_entity]) {
          yield _this.clearLocalCameraStream(_entity);
          yield _this.clearLocalScreenStream(_entity);
        }
      });
      return function (_x6) {
        return _ref16.apply(this, arguments);
      };
    }());
    _defineProperty(this, "removeStreamsByClient", _client => {
      logger.log('removeStreamsByClient', _client);
      if (!_client) return;
      if (_client === _classPrivateFieldGet(this, _myClient)) {
        _classPrivateFieldGet(this, _streams)[_client].forEach(_ref17 => {
          var {
            stream,
            _entity
          } = _ref17;
          this.streamRelease(stream);
          this.clearLocalStream(_entity);
        });
      }
      delete _classPrivateFieldGet(this, _streams)[_client];
    });
    _defineProperty(this, "removeStreamsByToken", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator(function* (token) {
        var allowStopLocalStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        logger.log('removeStreamsByToken', allowStopLocalStream, token);
        if (!token) return;
        var newStreams = {};
        yield Promise.all((0, _map.default)(_classPrivateFieldGet(_this, _streams), /*#__PURE__*/function () {
          var _ref19 = _asyncToGenerator(function* (allStreams, _client) {
            var streamsByClient = yield (0, _array.asyncFilter)(allStreams, /*#__PURE__*/function () {
              var _ref20 = _asyncToGenerator(function* (streamInfo) {
                if (streamInfo.token === token) {
                  if (_client === _classPrivateFieldGet(_this, _myClient) && allowStopLocalStream) {
                    logger.log('removeStreamsByToken:delete', streamInfo._entity, streamInfo === null || streamInfo === void 0 ? void 0 : streamInfo.trackLabel[0], streamInfo, allowStopLocalStream, token);
                    yield _this.streamRelease(streamInfo.stream);
                    _this.stopLocalTracks(streamInfo._entity);
                  }
                  return false;
                }
                return true;
              });
              return function (_x10) {
                return _ref20.apply(this, arguments);
              };
            }());
            if (streamsByClient !== null && streamsByClient !== void 0 && streamsByClient.length) newStreams[_client] = streamsByClient;
          });
          return function (_x8, _x9) {
            return _ref19.apply(this, arguments);
          };
        }()));
        _classPrivateFieldSet(_this, _streams, newStreams);
      });
      return function (_x7) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(this, "removeStreamsByEntity", _entity => {
      logger.log('removeStreamsByEntity', _entity);
      if (!_entity || _classPrivateFieldGet(this, _streams) && !Object.keys(_classPrivateFieldGet(this, _streams)).length) return;
      var newStreams = {};
      (0, _map.default)(_classPrivateFieldGet(this, _streams), (allStreams, _client) => {
        var streamsByClient = allStreams.filter(streamInfo => {
          if (streamInfo._entity === _entity) {
            if (_client === _classPrivateFieldGet(this, _myClient)) {
              this.streamRelease(streamInfo.stream);
              this.clearLocalStream(_entity);
            }
            return false;
          }
          return true;
        });
        if (streamsByClient !== null && streamsByClient !== void 0 && streamsByClient.length) newStreams[_client] = streamsByClient;
      });
      _classPrivateFieldSet(this, _streams, newStreams);
      this.clearLocalStream(_entity);
    });
    _defineProperty(this, "stopLocalTracks", _entity => {
      logger.log('stopLocalTracks: ', _entity);
      var localTracks = this.getLocalTracksByEntity(_entity);
      var streams = this.getAllStreamsInfo();
      var isTrackUsed = {
        audio: false,
        video: false
      };
      (0, _map.default)(streams, allStreams => {
        allStreams.forEach(streamInfo => {
          if (streamInfo.remote === false) {
            var vLocalTrack = streamInfo === null || streamInfo === void 0 ? void 0 : streamInfo.stream.getVideoTracks().find(t => {
              var _localTracks$video;
              return t.id === (localTracks === null || localTracks === void 0 || (_localTracks$video = localTracks.video) === null || _localTracks$video === void 0 ? void 0 : _localTracks$video.id);
            });
            var aLocalTrack = streamInfo === null || streamInfo === void 0 ? void 0 : streamInfo.stream.getAudioTracks().find(t => {
              var _localTracks$audio;
              return t.id === (localTracks === null || localTracks === void 0 || (_localTracks$audio = localTracks.audio) === null || _localTracks$audio === void 0 ? void 0 : _localTracks$audio.id);
            });
            if (vLocalTrack) {
              isTrackUsed.video = !!streamInfo._entity;
            }
            if (aLocalTrack) {
              isTrackUsed.audio = !!streamInfo._entity;
            }
          }
        });
      });
      if (!isTrackUsed.video) {
        this.clearLocalVideoStream(_entity);
      }
      if (!isTrackUsed.audio) {
        this.clearLocalAudioStream(_entity);
      }
    });
    _defineProperty(this, "setStreamTrackEnabled", (stream, kind, enabled, stopTrackOnDisable) => {
      if (stream && kind) {
        var tracks = (0, _streams2.getTracks)(stream, kind);
        if (tracks !== null && tracks !== void 0 && tracks.length) {
          tracks.forEach(track => this.setTrackEnabled(track, !!enabled, undefined, stopTrackOnDisable));
        } else {
          logger.warn('No track to mute/unmute');
        }
      }
    });
    _defineProperty(this, "mute", _ref21 => {
      var _classPrivateFieldGet22;
      var {
        _client,
        kind = 'audio',
        _entity,
        dispatchUpdate = true
      } = _ref21;
      var isOneStreamUpdated = false;
      if (!_client || !_entity) return;
      if (_client === _classPrivateFieldGet(this, _myClient)) {
        if (kind === 'audio' && _classPrivateFieldGet(this, _audioStreams)[_entity]) {
          this.setStreamTrackEnabled(_classPrivateFieldGet(this, _audioStreams)[_entity], kind, false);
          isOneStreamUpdated = true;
        }
        if ('video|screen|camera'.includes(kind) && _classPrivateFieldGet(this, _videoStreams)[_entity]) {
          this.setStreamTrackEnabled(_classPrivateFieldGet(this, _videoStreams)[_entity], kind, false);
          isOneStreamUpdated = true;
        }
      }
      if ((_classPrivateFieldGet22 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet22 !== void 0 && _classPrivateFieldGet22.length) {
        _classPrivateFieldGet(this, _streams)[_client].forEach((streamInfo, idx) => {
          if (streamInfo._entity === _entity) {
            this.setStreamTrackEnabled(streamInfo.stream, kind, false);
            isOneStreamUpdated = true;
            _classPrivateFieldGet(this, _streams)[_client][idx].updatedAt = Date.now();
          }
        });
      }
      if (dispatchUpdate && isOneStreamUpdated) {
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity,
          _client,
          hasAudio: false
        }));
      }
    });
    _defineProperty(this, "muteAllRemoteTracks", _ref22 => {
      var {
        kind = 'audio',
        _entity,
        dispatchUpdate = true
      } = _ref22;
      logger.log('muteAllRemoteTracks', {
        kind,
        _entity,
        dispatchUpdate
      });
      if (!_entity) return;
      (0, _map.default)(_classPrivateFieldGet(this, _streams), (_, _client) => _client !== _classPrivateFieldGet(this, _myClient) && this.mute({
        _client,
        kind,
        _entity,
        dispatchUpdate: false
      }));
      if (dispatchUpdate) {
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity
        }));
      }
    });
    _defineProperty(this, "unmute", _ref23 => {
      var _classPrivateFieldGet23, _classPrivateFieldGet24, _classPrivateFieldGet25;
      var {
        _client,
        kind = 'audio',
        _entity,
        dispatchUpdate = true
      } = _ref23;
      logger.log('unmute stream', {
        _client,
        kind,
        _entity,
        trackVideo: (_classPrivateFieldGet23 = _classPrivateFieldGet(this, _videoStreams)[_entity]) === null || _classPrivateFieldGet23 === void 0 || (_classPrivateFieldGet24 = _classPrivateFieldGet23.getVideoTracks) === null || _classPrivateFieldGet24 === void 0 ? void 0 : _classPrivateFieldGet24.call(_classPrivateFieldGet23),
        isScreenTack: (0, _streams2.isScreenSharingStream)(_classPrivateFieldGet(this, _videoStreams)[_entity])
      });
      var isOneStreamUpdated = false;
      if (!_client || !_entity) return;
      if (_client === _classPrivateFieldGet(this, _myClient)) {
        if (kind === 'audio' && _classPrivateFieldGet(this, _audioStreams)[_entity]) {
          this.setStreamTrackEnabled(_classPrivateFieldGet(this, _audioStreams)[_entity], kind, true);
          isOneStreamUpdated = true;
        }
        if ('video|screen|camera'.includes(kind) && _classPrivateFieldGet(this, _videoStreams)[_entity]) {
          this.setStreamTrackEnabled(_classPrivateFieldGet(this, _videoStreams)[_entity], kind, true);
          isOneStreamUpdated = true;
        }
      }
      if ((_classPrivateFieldGet25 = _classPrivateFieldGet(this, _streams)[_client]) !== null && _classPrivateFieldGet25 !== void 0 && _classPrivateFieldGet25.length) {
        _classPrivateFieldGet(this, _streams)[_client].forEach((streamInfo, idx) => {
          if (streamInfo._entity === _entity) {
            this.setStreamTrackEnabled(streamInfo.stream, kind, true);
            isOneStreamUpdated = true;
            _classPrivateFieldGet(this, _streams)[_client][idx].updatedAt = Date.now();
          }
        });
      }
      if (dispatchUpdate && isOneStreamUpdated) {
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity,
          _client,
          hasAudio: true
        }));
      }
    });
    _defineProperty(this, "unmuteAllRemoteTracks", _ref24 => {
      var {
        kind = 'audio',
        _entity,
        dispatchUpdate = true
      } = _ref24;
      logger.log('unmuteAllRemoteTracks', {
        kind,
        _entity,
        dispatchUpdate
      });
      if (!_entity) return;
      (0, _map.default)(_classPrivateFieldGet(this, _streams), (_, _client) => _client !== _classPrivateFieldGet(this, _myClient) && this.unmute({
        _client,
        kind,
        _entity,
        dispatchUpdate: false
      }));
      if (dispatchUpdate) {
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
          _entity
        }));
      }
    });
    _defineProperty(this, "purge", () => {
      logger.log('purge');
      (0, _map.default)(_classPrivateFieldGet(this, _streams), (allStreams, _client) => {
        allStreams.forEach(streamInfo => {
          var _streamInfo$stream;
          if (_client === _classPrivateFieldGet(this, _myClient) && (_streamInfo$stream = streamInfo.stream) !== null && _streamInfo$stream !== void 0 && _streamInfo$stream.release) {
            try {
              this.streamRelease(streamInfo.stream);
              this.clearLocalStream(streamInfo._entity);
            } catch (e) {
              //
            }
          }
        });
      });
      _classPrivateFieldSet(this, _streams, {});
    });
    _defineProperty(this, "streamRelease", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator(function* (stream) {
        try {
          var _stream$getTracks3, _stream$getTracks3$ca, _stream$getTracks3$ca2, _streamResolve$releas;
          logger.log('streamRelease', stream, stream === null || stream === void 0 || (_stream$getTracks3 = stream.getTracks) === null || _stream$getTracks3 === void 0 || (_stream$getTracks3$ca = (_stream$getTracks3$ca2 = _stream$getTracks3.call(stream)).map) === null || _stream$getTracks3$ca === void 0 ? void 0 : _stream$getTracks3$ca.call(_stream$getTracks3$ca2, track => "".concat(track.label, " - ").concat(track.kind, " - ").concat(track.id)));
          if (!stream) return;
          var streamResolve = yield stream;
          streamResolve.getTracks().forEach(track => {
            var _streamResolve$remove;
            (_streamResolve$remove = streamResolve.removeTrack) === null || _streamResolve$remove === void 0 || _streamResolve$remove.call(streamResolve, track);
          });
          return (_streamResolve$releas = streamResolve.release) === null || _streamResolve$releas === void 0 ? void 0 : _streamResolve$releas.call(streamResolve);
        } catch (e) {
          logger.warn('streamRelease:', e);
        }
      });
      return function (_x11) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(this, "hasCamera", _ref26 => {
      var {
        _client,
        _entity
      } = _ref26;
      return !!this.getCameraStream({
        _client,
        _entity
      });
    });
    _defineProperty(this, "hasScreen", _ref27 => {
      var {
        _client,
        _entity
      } = _ref27;
      return !!this.getScreenStream({
        _client,
        _entity
      });
    });
    _defineProperty(this, "hasVideo", _ref28 => {
      var {
        _client,
        _entity
      } = _ref28;
      return !!this.getVideoStream({
        _client,
        _entity
      });
    });
    _defineProperty(this, "hasAudio", _ref29 => {
      var {
        _client,
        _entity
      } = _ref29;
      return !!this.getAudioStream({
        _client,
        _entity
      });
    });
    _defineProperty(this, "setFocus", _ref30 => {
      var {
        _client,
        _entity
      } = _ref30;
      _classPrivateFieldGet(this, _focus)[_entity] = _client;
    });
    _defineProperty(this, "getFocus", _entity => _classPrivateFieldGet(this, _focus)[_entity]);
    _defineProperty(this, "getAllStreamsInfo", () => {
      var ret = {};
      (0, _map.default)(_classPrivateFieldGet(this, _streams), (allStreams, idx) => {
        ret[idx] = [];
        allStreams.forEach(streamInfo => {
          var _streamInfo$stream2;
          if ((_streamInfo$stream2 = streamInfo.stream) !== null && _streamInfo$stream2 !== void 0 && _streamInfo$stream2.getTracks) {
            ret[idx].push(_objectSpread(_objectSpread({}, streamInfo), {}, {
              tracks: streamInfo.stream.getTracks().map(track => JSON.stringify(track)),
              tracksTxt: streamInfo.stream.getTracks().map(track => "".concat(track.label, " - ").concat(track.kind, " - ").concat(track.id))
            }));
          }
        });
      });
      return ret;
    });
    _defineProperty(this, "getStreamInfoFromStreamId", streamId => {
      var ret;
      if (!streamId || streamId === _constants.JANUS_CLIENT_ID) return;
      (0, _map.default)(_classPrivateFieldGet(this, _streams), allStreams => {
        allStreams.forEach(streamInfo => {
          if (streamInfo.id === streamId) {
            ret = _objectSpread(_objectSpread({}, streamInfo), {}, {
              stats: this.getStats(streamId)
            });
          }
        });
      });
      return ret;
    });
    _defineProperty(this, "setStats", (streamId, stats) => {
      _classPrivateFieldGet(this, _stats)[streamId] = stats;
    });
    _defineProperty(this, "getStats", streamId => _classPrivateFieldGet(this, _stats)[streamId]);
    _defineProperty(this, "getStreamSummary", _ref31 => {
      var {
        _client,
        _entity
      } = _ref31;
      var audioStreams = this.getAudioStreams({
        _client,
        _entity,
        checkEnabled: false
      });
      var hasAudios = [];
      var hasAudiosInError = [];
      audioStreams.forEach(audioStream => {
        var _classPrivateFieldGet26;
        var [audioTrack] = (0, _streams2.getTracks)(audioStream, 'audio');
        hasAudios.push((0, _streams2.isTrackEnabled)(audioTrack));
        if ((_classPrivateFieldGet26 = _classPrivateFieldGet(this, _stats)[audioStream.id]) !== null && _classPrivateFieldGet26 !== void 0 && _classPrivateFieldGet26.audio) {
          var packets = parseInt(_classPrivateFieldGet(this, _stats)[audioStream.id].audio.packetsSent || _classPrivateFieldGet(this, _stats)[audioStream.id].audio.packetsReceived, 10);
          hasAudiosInError.push((0, _streams2.isTrackEnabled)(audioTrack, false) && !packets);
        }
      });
      var videoStreams = this.getVideoStreams({
        _client,
        _entity,
        checkEnabled: false
      });
      var hasVideos = [];
      var hasVideosInError = [];
      var hasScreens = [];
      var hasScreensInError = [];
      videoStreams.forEach(videoStream => {
        var _classPrivateFieldGet27;
        var [videoTrack] = (0, _streams2.getTracks)(videoStream, 'video');
        if ((0, _streams2.isScreenTrack)(videoTrack)) {
          hasScreens.push((0, _streams2.isTrackEnabled)(videoTrack));
        } else {
          hasVideos.push((0, _streams2.isTrackEnabled)(videoTrack));
        }
        if ((_classPrivateFieldGet27 = _classPrivateFieldGet(this, _stats)[videoStream.id]) !== null && _classPrivateFieldGet27 !== void 0 && _classPrivateFieldGet27.video) {
          var packets = parseInt(_classPrivateFieldGet(this, _stats)[videoStream.id].video.packetsSent || _classPrivateFieldGet(this, _stats)[videoStream.id].video.packetsReceived, 10);
          if ((0, _streams2.isScreenTrack)(videoTrack)) {
            hasScreensInError.push((0, _streams2.isTrackEnabled)(videoTrack, false) && !packets);
          } else {
            hasVideosInError.push((0, _streams2.isTrackEnabled)(videoTrack, false) && !packets);
          }
        }
      });
      var currVideoStream = this.getCameraStream({
        _client,
        _entity
      });
      var currScreenStream = this.getScreenStream({
        _client,
        _entity
      });
      var currAudioStream = this.getAudioStream({
        _client,
        _entity
      });
      var streamId = (currScreenStream === null || currScreenStream === void 0 ? void 0 : currScreenStream.id) || (currVideoStream === null || currVideoStream === void 0 ? void 0 : currVideoStream.id) || (currAudioStream === null || currAudioStream === void 0 ? void 0 : currAudioStream.id);
      var streamInfo = this.getStreamInfoFromStreamId(streamId);
      return {
        updatedAt: (streamInfo === null || streamInfo === void 0 ? void 0 : streamInfo.updatedAt) || Date.now(),
        hasAudio: hasAudios.includes(true),
        hasAudioInError: hasAudiosInError.includes(true),
        hasVideo: hasVideos.includes(true),
        hasVideoInError: hasVideosInError.includes(true),
        hasScreen: hasScreens.includes(true),
        hasScreenInError: hasScreensInError.includes(true),
        streamId
      };
    });
  }
}
var _default = exports.default = (0, _debug.addDebugAttribute)(new StreamManager(), 'StreamManager');
module.exports = exports.default;